import { executeUI } from '@common/utils/ui-bridge';
import client from '@common/utils/rest';
import { getQueriesAsSearch } from '@common/utils';
import { SORT_DIRECTION } from '@common/constants';

const URL_PREFIX_LETTERS = 'letters/data/templates';
const URL_PREFIX_LETTER = 'letters/data/template';

const nonFolderId = -1;

export const getLetters = ({ filtering, pagination, sorting = {} }) => {
	const { searchKeyword, folderId, ...otherFilteringQueries } = filtering;

	const params = {
		folderId: folderId || nonFolderId,
		searchQuery: searchKeyword,
		...otherFilteringQueries,
		...pagination,
		sortColIndex: sorting.columnIndex || 1,
		sort: true,
		sortAsc: sorting.direction === SORT_DIRECTION.asc
	};

	return client({
		path: `${URL_PREFIX_LETTERS}${getQueriesAsSearch(params)}`,
		method: 'GET',
	}).then((x) => {
		return x.entity;
	});
};

export const deleteLetter = (id) => {
	return client({
		params: {
			templateId: id,
		},
		path: `${URL_PREFIX_LETTER}/removeTemplate`,
		method: 'POST'
	});
};

export { getFilters } from '@common/actions/Filters';

export const renameLetter = ({ letterId, name }) => {
	return client({
		params: {
			templateId: letterId,
			newTemplateName: name,
		},
		path: `${URL_PREFIX_LETTER}/renameTemplate`,
		method: 'POST'
	});
};

export const moveLetter = ({ letterId, folderId }) => {
	return client({
		params: {
			templateId: letterId,
			toFolderId: folderId,
		},
		path: `${URL_PREFIX_LETTER}/moveTemplate`,
		method: 'POST'
	});
};

const MODULE_NAME = 'LETTERS';

export const openLetter = (letterId) => {
	executeUI(MODULE_NAME, 'editTemplate', letterId);
};

export const openLetterCreation = (folderId) => {
	return executeUI(MODULE_NAME, 'newTemplate', folderId);
};